<template>
  <div class="modal" id="regtenantModal" tabindex="-1" aria-labelledby="regLabel" aria-hidden="true"
    data-bs-backdrop="static" data-bs-keyboard="false">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header  headclr">
          <h5 class="modal-title" id="exampleModalLabel"> {{ headernameM }}</h5>
          <div class="close-container myfaBtn" data-bs-dismiss="modal" aria-label="Close">
            <div class="leftright"></div>
            <div class="rightleft"></div>
          </div>
        </div>
        <div class="modal-body modal-bodyHt mdclr" style="font-size:0.9rem">
          <h4 v-if="Freshacc" class="text-center themeclr2" v-on:click="checksamp()">
            Welcome To Opsight
          </h4>
          <div v-if="Freshacc" class="text-center"> <i class="fas fa-laptop themeclr2"></i> Kindly Register in
            a Tenant to get started </div>
          <form name="userForm1" method="POST" role="form" v-show="shwregisterM" autocomplete="off"
            style="margin-top: 15px;" class="userform">
            <label class="wht">
              Select Tenant
            </label>
            <VueMultiselect class="mymultiselect  hide-on-presentation " openDirection="bottom" v-model="BusinessUnit" :options="bussiness"
              :multiple="false" :allow-empty="false" selectLabel="" deselect-label="can't Deselect"
              :close-on-select="true" label="bu" track-by="bu">
              <template v-slot:option="{ option }" >
                <div :title="option.name">
                  {{ option.bu }}
                </div>
              </template>
            </VueMultiselect>
            <span class="effect btn-register eff-md mr20top float-right" v-on:click="registerBU(BusinessUnit)">Register
            </span>
            <span class="effect btn-back eff-md eff-md mr20top float-right" v-show="drillbak" v-on:click="backTo()"
              style="margin-right: 10px;">
              Go Back
            </span>
          </form>
          <div class="row bkHldr hdpads" v-show="!shwregisterM">
            <div class="col-7">
              <label class="currBlbl">
                <i class="fas fa-hand-point-right"></i>
                Currently in
              </label>
              <span class="currbulis secondaryTxt" style="margin-left: 10px;font-weight: 600;">{{ curr_bu }}
                <i class="fas fa-briefcase"></i>
              </span>
            </div>
            <div class="col-5">
              <span class="uSpl" v-on:click="selectNewBU()">Register for new Tenant</span>
            </div>
            <div class="input-group" style="margin:15px 0">
              <span class="input-group-addon"> <i class="fa fa-search" aria-hidden="true"></i></span>
              <input type="text" v-model="searchunit" v-model.lazy="searchunit" class="form-control mr10top"
                placeholder="">
            </div>
            <div v-for="(val) in BU_listF" :key="val" class="col col-6 col-sm-4 col-lg-3"
              v-bind:class="{ 'selectedswtch': val.unit == on, 'BlurClass': !(val.valid == 'True' && val.status == 'Active') }"
              data-bs-toggle="tooltip"
              :title="val.valid != 'True' ? val.unit + ' Tenant Access : Expired \nExpired Date : ' + val.due_date : val.status == 'Active' ? val.unit + ' Tenant Access : Active \nExpiry Date : ' + val.due_date : val.unit + ' Tenant Access : Not Approved'">
              <div class="myCard swtchCard" style="width:100%;margin:0 0 10% 0;">
                <a class="secondaryTxt" v-on:click="selectBu(val.unit, val.valid, val.status)">
                  <div class="text-center">
                    <div class="swtchUnits">
                      <i class="fas fa-briefcase swtchIco" :style="'stroke:'+val.color"></i>
                    </div>
                    <div class="assessmentName" :style="'color:'+val.color">{{ val.unit }}</div>
                  </div>
                </a>
              </div>
            </div>
            <div style="margin-top: 25px;">
              <div>Legend</div>
              <div class="row">
                <div class="col-6">
                  <span class="legend" style="background-color: #00b037;"></span> <span class="legendTxt">No Action Required</span>
                </div>
                <div class="col-6">
                  <span class="legend" style="background-color: #777777;"></span> <span class="legendTxt">Not Approved</span>
                </div>
                <div class="col-6">
                  <span class="legend" style="background-color: #b00000;"></span> <span class="legendTxt">Expired</span>
                </div>
                <div class="col-6">
                  <span class="legend" style="background-color: #cc5500;"></span> <span class="legendTxt">Will Expire in 7 days</span>
                </div>
                <div class="col-6">
                  <span class="legend" style="background-color: #ecc257;"></span> <span class="legendTxt">Will Expire in 14 days</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    Modal
  } from 'bootstrap';
  export default {
    name: 'TenantReg',
    components: {},
    props: {
      headerpass: String
    },
    data() {
      return {
        searchunit: "",
        modal: undefined,
        buloader: false,
        Freshacc: false,
        shwregisterM: true,
        userInfo: {},
        bussiness: [],
        BusinessUnit: "",
        curr_bu: "",
        headernameM: "",
        BU_list: [],
        on: false,
        drillbak: false
      }
    },
    computed: {
      decideColor() {
        let color = "auto";
        return color
      },
      BU_listF() {
        let newList = [];
        for (let i = 0; i < this.BU_list.length; i++) {
          const element = this.BU_list[i];
          let todayDate = new Date();
          let BuExpiryDate = new Date(element.due_date);
          let Difference_In_Time = BuExpiryDate.getTime() - todayDate.getTime();
          let Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
          let daysValue = Math.trunc(Difference_In_Days)
          if (element.status == "Not Approved") {
            element.color = '#777777'
          } else if (element.status == "Expired") {
            element.color = '#b00000'
          } else if (daysValue <= 7) {
            element.color = '#cc5500'
          } else if (daysValue <= 15) {
            element.color = '#ecc257'
          } else {
            element.color = '#00b037'
          }
          if (element.unit.substr(0, this.searchunit.length).toUpperCase() == this.searchunit.toUpperCase()) {
            newList.push(element)
          }
        }
        return newList
      },

    },
    methods: {
      registerBU(BusinessUnit) {
        const emit = this.$emit;
        emit("onRegisterload", {
          'loader': true,
          'BuName': ''
        })
        this.buloader = true
        if (BusinessUnit == undefined) {
          this.$notify({
            type: "error",
            text: "Tenant cannot be left blank!"
          })
          this.buloader = false
        }
        const article = {
          BusinessUnit: BusinessUnit.bu
        };
        this.axios.post(this.uriApiUrl + 'UserSetting/register_bu', article,{
      headers: {
            'Content-Type': 'application/json'
          }})
          .then((response) => {
            if (response.status == 200) {
              if (response.data == "Success") {
                this.$notify({
                  type: "success",
                  text: 'Tenant Registeration was successful!'
                })
                this.buloader = true
                let index = this.userInfo.All_BU.indexOf(this.BusinessUnit);
                if (index > -1) {
                  this.userInfo.All_BU.splice(index, 1);
                }
                this.$sessionData.set('uinofo_sess', this.userInfo)
                this.BusinessUnit = ""
                this.modal.hide()
              } else if (response.data == "BUExists") {
                this.$notify({
                  type: "error",
                  text: "UserName with Selected Tenant already registered! Please Choose Different Tenant"
                })
                this.buloader = true
              } else {
                this.$notify({
                  type: "error",
                  text: "Error Occured during Tenant Registration ! Please try again."
                })
                this.buloader = true;
              }
              emit("onRegisterload", {
                'loader': false,
                'BuName': ''
              })
            }
          }).catch((error) => {
            emit("onRegisterload", {
              'loader': false,
              'BuName': ''
            })
            this.$notify({
              type: "error",
              text: "Error Occured during Tenant Registration ! Please try again."
            })
          })
      },
      selectNewBU() {
        this.shwregisterM = true
        this.drillbak = true
      },
      backTo() {
        this.shwregisterM = false
      },
      selectBu(tenant, isvalid, status) {
        if (isvalid == 'True' && status == 'Active') {
          this.buloader = true
          this.axios.post(this.uriApiUrl + 'UserSetting/choose_bu', tenant)
            .then((response) => {
              if (response.status == 200) {
                if (response.data == "Error") {
                  this.$notify({
                    type: "error",
                    text: "something went wrong! Please try again after sometime"
                  })
                } else {
                  this.userInfo = response.data
                  this.$notify({
                    type: "success",
                    title: '<i class="fas fa-door-open"></i>&nbsp; Hi &nbsp;' + this
                      .userInfo.UserName + ' <br> ',
                    text: "Business unit to" + ' <b> ' + tenant + ' </b> ' +
                      ' has been successfully switched'
                  });
                  this.$parent.GetbookMarkData(0, 1);
                  this.$parent.GetassessmentData();
                  this.$parent.getAccAndTech()
                  this.$parent.curr_bu = this.userInfo.Curr_BU;
                  this.modal.hide()
                }
              }
            }).catch((error) => {
              this.$notify({
                type: "error",
                text: "Error Occured during Tenant Registration ! Please try again."
              })
            })
        } else {
          this.$parent.showReminderList = true
          this.modal.hide()
        }
      },
      showRegModal(shwregisterM, headernameM) {
        this.shwregisterM = shwregisterM;
        this.headernameM = headernameM;
        this.Freshacc = true;
        this.userInfo = this.$sessionData.get('uinofo_sess')
        this.bussiness = this.userInfo.All_BU;
        if (this.userInfo != null) {
          if (this.userInfo.BU_list == undefined) {
            this.BU_list = []
          } else {
            this.BU_list = this.userInfo.BU_list
            this.curr_bu = this.userInfo.Curr_BU
          }
        }
        this.modal.show();
      },
      checksamp() {
        this.shwregisterM = true,
          this.headername1 = "headernameM"
      }
    },
    mounted() {
      this.modal = new Modal(document.getElementById('regtenantModal'))
    },
    created() {}
  }
</script>
<style scoped>
  .legend {
    display: inline-block;
    height: 10px;
    width: 10px;
  }

  .legendTxt{
    position: relative;
    top: -8px;
    font-size: 0.75rem;
  }

  .BlurClass{
    opacity: 0.8;
  }
  .darkTheme .modal-content {
    color: #dddddd !important;
  }
</style>